<template>
  <div id="albums">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute class="mr-5 pf-btn-fab" :to="{ path: 'imageDownload'}" v-if="albumList.filter(item => (item.type === 'Normal') || (item.type === 'Profile')).length > 0" style="right:50px">
            <v-icon>save_alt</v-icon>
          </v-btn>
          <v-btn fab absolute right class="mr-3 pf-btn-fab" @click="addAlbum">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="isListEmpty" class="text-center">
        <img src="static/NoPictures.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Album(s) Found !! </b></h4>
    </v-container>
    <v-container grid-list-md fluid v-if="albumList.length > 0">
      <draggable
        v-model="albumList"
        class="layout wrap row"
        handle=".handle"
        @start="drag=true"
        @end="drag=false;"
        forceFallback= "false"
      >
        <v-flex v-for="albumItem of albumList" :key="albumItem.id" xs12 sm6 md4 lg3 pa-2 v-show="(albumItem.type === 'Normal') || (albumItem.type === 'Profile') || (albumItem.type === 'Avatar')">
          <v-card :class="{ newAlbum: albumItem.setNew ? albumItem.setNew : '' }" >
            <router-link :to="{ path: `photos/${albumItem.id}`}">
              <div
                class="image_class"
                :style="`background-image: url('${albumItem.default_photo.thumb_url}');`"
                v-if="albumItem.default_photo && albumItem.photo.length"
              ></div>
              <div class="image_class" :style="`background-image: url(${newAlbum.src});`" v-else></div>
            </router-link>
            <v-flex class="pl-1 pr-1 mb-0">
              <h5
                v-if="isSave == false || currentEditor != albumItem.id"
                id="albumName"
                class="pa-1 title-display"
              >
              <div v-on:click="showAlbumEdit(albumItem);">
                    <span v-if="albumItem.name">{{ albumItem.name }}</span>
                    <span v-else>Add title here</span>
                </div>
              </h5>
                <v-text-field
                  v-if="isSave && currentEditor == albumItem.id"
                  v-model.trim="editData.name"
                  autofocus
                  :hide-details="true"
                  class="pr-1 pt-1 text-edit-field"
                  height="20"
                  @change="saveEdited"
                ></v-text-field>
            </v-flex>
            <v-divider horizontal class="pf-divider"></v-divider>
            <v-flex flat class="text-xs-right pl-1 pr-1">
              <v-btn icon class="ma-0 handle">
                <v-icon size="22" color="grey darken-2">open_with</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" @click="downloadAlbum(albumItem)">
                <v-icon size="22" color="grey darken-2">save_alt</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" v-show="albumItem.type === 'Normal'">
                <v-icon
                  v-on:click="deleteAlbum(albumItem)"
                  size="22"
                  color="grey darken-2"
                >delete_outline</v-icon>
              </v-btn>
            </v-flex>
          </v-card>
        </v-flex>
      </draggable>
    </v-container>
  </div>
</template>
<script>
import swal from 'sweetalert2';
import { getOne, getCollection, update, remove, create, sortList, updateSortList } from '../helpers/helpers';
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';
import JsZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';
/* global session store */
export default {
  components: {
    draggable
  },
  data: () => ({
    entity: 'Album',
    roleEntity: 'Account',
    isListEmpty: false,
    latestAlbum: {},
    editIndex: -1,
    editData: {},
    album: {
      name: `New Album`,
      photo: [],
      default: {},
    },
    newAlbum: {
      name: 'Latest',
      src: '/static/album-icon.jpg',
      style: 'border: 3px solid #7ac142'
    },
    isSave: false,
    currentEditor: 0,
    dialog: false,
    currentDeleteItem: null,
    currentEditorIndex: null,
    currentData: {}
  }),
  computed: {
    ...mapGetters(['AlbumPhoto', 'Account', 'Child']),
    albumList: {
      get () {
        return store.state.Album;
      },
      set (value) {
        updateSortList(this.entity, value, this.roleEntity, session.getSession().adminUser ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : 'Me');
        store.commit('setAlbum', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : this.roleEntity;
    this.initialize();
  },
  methods: {
    async initialize () {
      if (!this.albumList.length) {
        let entity = 'Album';
        let sessionUser = session.getSession();
        let where = {};
        if (sessionUser.adminUser) {
          where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
        }
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log('error', error);
        } else {
          if (data.length > 0) {
            this.albumList = sortList(this.entity, data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity.toLowerCase()].id : 'Me');
            if (this.albumList.filter(item => (item.type === 'Normal') || (item.type === 'Profile') || (item.type === 'Avatar')).length === 0) {
              this.isListEmpty = true;
            }
          } else {
            this.isListEmpty = true;
          }
        }
      } else {
        if (this.albumList.filter(item => (item.type === 'Normal') || (item.type === 'Profile') || (item.type === 'Avatar')).length === 0) {
          this.isListEmpty = true;
        }
        // Remove the green border for the new album
        if (this.albumList.length && this.albumList[0].setNew && this.albumList[0].setNew === true) {
          delete this.albumList[0].setNew;
        }
      }
    },
    showAlbumEdit (item) {
      this.currentEditorIndex = this.albumList.findIndex(albumitem => albumitem.id === item.id);
      this.currentEditor = item.id;
      if (item.type === 'Normal') {
        this.isSave = true;
      }
      else {
        this.isSave = false;
      }
      this.currentData = { ...item };
      this.editData = { ...item };
    },
    async addAlbum () {
      let d = new Date();
      let newDate = d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
      this.album.name = `New Album  ( ${newDate} )`;
      
      const { value: albumName } = await swal.fire({
        title: 'Enter album name',
        input: 'text',
        inputValue: this.album.name,
        showCancelButton: true,
        confirmButtonText: 'Save',
        customClass: {
          confirmButton: 'pf-btn pf-btn-save saveCancel-btn',
          cancelButton: 'pf-btn pf-btn-cancel saveCancel-btn'
        },
        inputValidator: (value) => {
          if (!value) {
            return 'Please enter album name!';
          }
          const albumIndex = this.albumList.findIndex(item => item.name.toLowerCase() === value.toLowerCase());
          if (albumIndex >= 0) {
            return 'Album name already exists!';
          }
        }
      });

      if (albumName) {
        this.album.name = albumName;
        // if (albumIndex === -1) {
        if (session.getSession().adminUser) {
          this.album[this.roleEntity.toLowerCase()] = session.getSession().user.human[this.roleEntity.toLowerCase()].id;
        }
        let { error, data, status } = await create(this.entity, this.album);
        if (error) {
          console.log('error', error);
        } else {
          this.loading = false;
          if (this.albumList.length && this.albumList[0].setNew && this.albumList[0].setNew === true) {
            this.albumList[0].setNew = false;
          }
          data.setNew = true;
          this.albumList.splice(0, 0, data);
          this.isListEmpty = false;
          this.latestAlbum = data;
          let albumItem = {
            sort_no: 0,
            album: data.id
          };
          this[this.roleEntity].album.unshift(albumItem);
          swal.fire({
            type: 'success',
            title: 'Album added successfully',
            showConfirmButton: false,
            timer: 2500
            // onClose: () => {
            //   this.$router.push({ path: "/albums" });
            // }
          });
        }
        // }
        // else {
        //   swal.fire(`The album name already exist`);
        // }
      }
    },
    deleteAlbum (item) {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
        .then(result => {
          if (result.value) {
            (async () => {
              let { error, data, status } = await remove(this.entity, item.id);
              if (error) {
                console.log('error', error);
              } else {
                const index = this.albumList.indexOf(item);
                this.albumList.splice(index, 1);
                if (this.albumList.filter(item => (item.type === 'Normal') || (item.type === 'Profile') || (item.type === 'Avatar')).length === 0) this.isListEmpty = true;
                let deletedAlubmItemIndex = this[this.roleEntity].album.findIndex(album => album.album === item.id);
                this[this.roleEntity].album.splice(deletedAlubmItemIndex, 1);
                if (this.AlbumPhoto[item.id]) {
                  this.AlbumPhoto[item.id].splice(index, 1);
                }
                swal.fire(
                  'Deleted!',
                  'Album "' + item.name + '" has been deleted.',
                  'success'
                );
              }
            })();
          }
        });
    },
    async saveEdited () {
      if (this.currentEditorIndex != null) {
        let editorIndex = this.currentEditorIndex;
        let editedData = { ...this.editData };
        const albumIndex = this.albumList.findIndex(item => item.name.toLowerCase() === editedData.name.toLowerCase());
        if (albumIndex === -1) {
          this.currentEditorIndex = null;
          let { error, data, status } = await update(
            this.entity,
            editedData,
            editedData.id
          );
          if (error) {
            console.log('error', error);
          } else {
            this.albumList[editorIndex] = { ...data };
            this.loading = false;
            this.currentEditor = null;
            editorIndex = null;
            swal.fire({
              type: 'success',
              title: 'Album name updated successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.isSave = false;
                window.getApp.$emit('pageSubHeader', '');
              }
            });
          }
        }
        else {
          swal.fire(`Album name already exists`);
          this.editData = { ...this.currentData };
          this.isSave = false;
        }
      }
    },
    async downloadAlbum (item) {
      let { error, data } = await getOne('Album', item.id);
      if (error) {
        console.log('error', error);
      } else {
        const photos = [];
        for (let i = 0; i < data.photo.length; i++) {
          photos.push(data.photo[i].photo);
          data.photo[i].photo = data.photo[i].photo.id;
        }
        let zip = new JsZip();
        let count = 0;
        let zipName = item.name + '.zip';
        if (photos.length !== 0) {
          photos.forEach(function (url) {
            let filename = url.filename;
            if (url.original_url) {
              let hostHttps = window.location.origin.indexOf('https');
              let newUrl = '';
              if (hostHttps === -1) {
                newUrl = url.original_url.replace('https', 'http');
              }
              else {
                newUrl = url.original_url;
              }
              JSZipUtils.getBinaryContent(newUrl, function (err, data) {
                if (err) {
                  throw err; // or handle the error
                }
                zip.file(filename, data, { binary: true });
                count++;
                if (count === photos.length) {
                  swal.fire({
                    type: 'success',
                    title: 'Your album is downloading, please wait...',
                    showConfirmButton: false,
                    timer: 2500,
                    onClose: () => {
                      //
                    }
                  });
                  zip.generateAsync({ type: 'blob' }).then(function (content) {
                    saveAs(content, zipName);
                  
                  });
                }
              });
            }
          });
        }
        else {
          swal.fire({
            type: 'warning',
            title: 'No photos to download',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              //
            }
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.button_div {
  min-height: 60px;
  position: relative;
}
.image_class {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 240px;
}
.title-display {
  padding-top: 6px !important;
}
.text-edit-field {
  padding-left: 4px;
  padding-bottom: 6px;
}
.newAlbum{
  border: 3px solid #7ac142 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Albums.vue